module.exports = __webpack_public_path__ + "static/media/gmc-go-drive.1bc6823e.png";